<template>
  <TeacherForm
    :title="$t('teacher.addTitle')"
    :submit-text="$t('teacher.addTeacher')"
    :on-submit="handleAdd"
  />
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { upsertTeacher } from '@/api/teacher'
import TeacherForm from '@/components/TeacherForm.vue'

const router = useRouter()

const handleAdd = async (formData) => {
  const data = {
    ...formData,
    isVisibleForMiniApp: Boolean(formData.isVisibleForMiniApp)
  }
  await upsertTeacher(data)
  ElMessage.success('Teacher added successfully')
  router.push('/teacher')
}
</script>
